import {
    put, takeLatest,
} from 'redux-saga/effects';

import {
    addToUncollapsedGroups,
    removeFromUncollapsedGroups,
    SET_COLLAPSED_STATE,
} from '../reduxModules/ConsentManagementPlatform';

export function* callAction(action) {
    const { isCollapsed, cookieGroupId } = action.payload;

    if (!isCollapsed) {
        yield put(addToUncollapsedGroups(cookieGroupId));
    } else {
        yield put(removeFromUncollapsedGroups(cookieGroupId));
    }
}

export function* watch() {
    yield takeLatest(SET_COLLAPSED_STATE, callAction);
}
